export const SURVEY_JOURNEYS = ['NEW_PATIENT', 'OPU', 'ET'] as const;

export type SurveyJourney = (typeof SURVEY_JOURNEYS)[number];

export const JOURNEY_LABELS: Record<SurveyJourney, string> = {
  NEW_PATIENT: 'New Patient',
  OPU: 'Day of OPU',
  ET: 'Day of ET',
};

export function isSurveyJourney(value: unknown): value is SurveyJourney {
  return typeof value === 'string' && SURVEY_JOURNEYS.includes(value as SurveyJourney);
}
